export default __webpack_public_path__ + "static/illustration-content-btn.url-36c83bac2f6e15b1d250dcd09631249a.svg";